import React, { Component } from 'react';

class RewardDeliveryAddress extends Component {
  render() {
    const { address1, address2, address3, eircode } = this.props;

    return (
      <div>
        <div className="my-rewards-info-address-container">
          <div className="my-rewards-info-row">
            DELIVERY ADDRESS:
          </div>
          <div className="my-rewards-info-row">
            {address1}
          </div>
          <div className="my-rewards-info-row">
            {address2}
          </div>
          <div className="my-rewards-info-row">
            {address3}
          </div>
          <div className="my-rewards-info-row">
            {eircode}
          </div>
        </div>
      </div>
    );
  }
}

export default RewardDeliveryAddress;



// WEBPACK FOOTER //
// ./src/components/my-rewards/reward-delivery-address.jsx